import React from 'react';

import { FormikErrors, FormikTouched } from 'formik';

import { OptionalProps } from '@rbi-ctg/frontend';
import { DateInput, DateInputName, IDateInputProps } from 'components/ucl';
import { t } from 'state/intl/translations';

interface IFormikBirthdayInputProps {
  year: string;
  month: string;
  day: string;
  onChange?: (inputName: DateInputName, inputText: string) => void;
  onBlur?: (inputName: DateInputName) => void;
  dobTouched?: FormikTouched<{ year: string; month: string; day: string }> | undefined;
  dobErrors?: FormikErrors<{ year: string; month: string; day: string }> | undefined;
  isRequired?: boolean;
}

export const FormikBirthdayInput = ({
  year,
  month,
  day,
  onChange,
  onBlur,
  dobTouched,
  dobErrors,
  disabled,
  hintMessage,
  isRequired = false,
}: IFormikBirthdayInputProps &
  OptionalProps<
    IDateInputProps,
    | 'label'
    | 'labelYear'
    | 'labelYearFormat'
    | 'labelMonth'
    | 'labelMonthFormat'
    | 'labelDay'
    | 'labelDayFormat'
  >) => {
  const touched =
    typeof dobTouched === 'boolean'
      ? dobTouched
      : dobTouched?.year || dobTouched?.month || dobTouched?.day;

  const errors = dobErrors ? '' + dobErrors.year + dobErrors.month + dobErrors.day : undefined;
  const errorMessage = touched ? errors : undefined;

  return (
    <DateInput
      required={isRequired}
      testID="dateOfBirth"
      autoComplete="bday"
      disabled={disabled}
      labelYear={t('year')}
      labelYearFormat={t('yearPlaceholder')}
      labelMonth={t('month')}
      labelMonthFormat={t('monthPlaceholder')}
      labelDay={t('day')}
      labelDayFormat={t('dayPlaceholder')}
      errorMessage={errorMessage}
      onBlur={onBlur}
      onChange={onChange}
      month={month}
      day={day}
      year={year}
      hintMessage={hintMessage}
    />
  );
};
